require.register("attachment/app", function(exports, require, module){
  $0
  
});

